import { render, staticRenderFns } from "./AppointmentsList.vue?vue&type=template&id=b82e9942&scoped=true"
import script from "./AppointmentsList.vue?vue&type=script&lang=js"
export * from "./AppointmentsList.vue?vue&type=script&lang=js"
import style0 from "./AppointmentsList.vue?vue&type=style&index=0&id=b82e9942&prod&lang=scss&scoped=true"
import style1 from "./AppointmentsList.vue?vue&type=style&index=1&id=b82e9942&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b82e9942",
  null
  
)

export default component.exports